// Development mock translations
export default {
	'mks.notifications.close': 'close',
};
